import { apiWrapper, apiCancel } from '../../wrapper'

export const initial = 'user'
const baseUrl = process.env.REACT_APP_SERVICE_CORE_URL
const appCode = process.env.REACT_APP_SERVICE_CORE_APPCODE
const outputType = 'json'


export const userGetData = 'user/getData/'
export const PunishmentPeriodList = 'Kepegawaian/Hukdis/daftarperiodehukdis/'
export const PromotionPeriodList = 'Kepegawaian/KenaikanPangkat/daftarperiodekenaikanpangkat/'
export const PunishmentPegawaiList = 'Kepegawaian/Hukdis/daftarperiodehukdislistdaftarpegawai/'
export const generate = 'Kepegawaian/Hukdis/daftarperiodehukdislistdaftarpegawaigenerate/'
export const listunproccess = 'Kepegawaian/Hukdis/list_hukdis_unprocess/'
export const listmanual = 'Kepegawaian/Hukdis/list_hukdis_manual/'
export const listunproccessatasan = 'Kepegawaian/Hukdis/list_hukdis_unprocess_atasan/'
export const PromotionPeriodDetail = 'Kepegawaian/KenaikanPangkat/detailperiodekenaikanpangkat/'
export const PunishmentPeriodDetail = 'Kepegawaian/Hukdis/PunishmentPeriodDetail/'
export const PromotionPegawaiCreate = 'Kepegawaian/KenaikanPangkat/daftarpegawaicreate/'
export const daftarpegawai = 'Kepegawaian/KenaikanPangkat/daftarpegawai/'
export const daftarpangkat = 'Kepegawaian/KenaikanPangkat/daftarpangkat/'
export const PromotionPegawaiDetail = 'Kepegawaian/KenaikanPangkat/daftarperiodekenaikanpangkatdetaildaftarpegawai/'
export const PromotionPegawaiApprove = 'Kepegawaian/KenaikanPangkat/approvepegawai/'
export const PromotionPeriodApprove = 'Kepegawaian/KenaikanPangkat/approveeriode/'
export const PunishmentPeriodDelete = 'Kepegawaian/Hukdis/deletePeriode/'
export const kenaikanpangkaInactive = 'Kepegawaian/KenaikanPangkat/inactive/'
export const PromotionDeleteSKC = 'Kepegawaian/KenaikanPangkat/deleteSKC/'
export const HDDownloadSP = 'Kepegawaian/Hukdis/downloadDraftSP/'
export const punishmentPeriodCreate = 'Kepegawaian/Hukdis/daftarperiodehukdiscreate/'
export const PunishmentManualList = 'Kepegawaian/Hukdis/listmanualhukdis/'
export const HDdetail = 'Kepegawaian/HukumanDisiplin/detail/'

export const prosesPegawai = 'Kepegawaian/Hukdis/prosesPegawai/'
export const generatePegawai = 'Kepegawaian/KenaikanPangkat/generatePegawai/'
export const downloadDraftSK = 'Kepegawaian/KenaikanPangkat/downloadDraftSK/'

export const berkasGet = 'Kepegawaian/KenaikanPangkat/berkasGet/'
export const berkasUpload = 'Kepegawaian/KenaikanPangkat/berkasUpload/'
export const exportExcelUsulan = 'Kepegawaian/KenaikanPangkat/exportExcelUsulan/'

export const inputSK = 'Kepegawaian/KenaikanPangkat/inputSK/'

export const createSKCollective = 'Kepegawaian/KenaikanPangkat/createSKCollective/'
export const listSKCollective = 'Kepegawaian/KenaikanPangkat/listSKCollective/'
export const downloadSKCollective = 'Kepegawaian/KenaikanPangkat/downloadSKCollective/'
export const deleteSKCollective = 'Kepegawaian/KenaikanPangkat/deleteSKCollective/'

export const cancelToken = () => {
    return apiCancel()
}
export const apiRequest = async (method, route, data = { params: null, body: null, cancelToken: null }, needToken=true) => {
    if(needToken) {
        const thisTime = (Math.floor(Date.now()/1000))
        const expire = localStorage.getItem(initial + 'accessExpired')
        if(expire < thisTime) {
           await apiWrapper(baseUrl, initial, appCode, outputType, 'post', 'auth/getAccessToken/', data)
           .then(result => {
                localStorage.setItem(initial + 'accessToken', result.response.access_token)
                return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data)
            })
            .catch(result => {
                return Promise.reject('Tidak dapat mengambil accessToken');
            })
        } else {
            return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data)        
        }
    }
    return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data)
}